import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Button, Card, Grid, Typography, Tooltip } from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { Link } from 'react-router-dom';

// project imports
import { gridSpacing } from 'store/constant';
import { LOAD_BILLER } from 'store/actions';
import { useDispatch } from 'react-redux';

// ==============================|| PAYNOW BILLER CARD ||============================== //

const PaynowBillerCard = (billerData) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const btnSX = {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[200],
        background: theme.palette.mode === 'dark' ? theme.palette.dark.dark : theme.palette.background.paper
    };

    return (
        <Card
            sx={{
                p: 2,
                background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                border: '1px solid',
                borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[100],
                '&:hover': {
                    border: `1px solid${theme.palette.primary.main}`
                }
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item>
                            {billerData.logo && <Avatar alt={billerData.biller_name} src={billerData.logo} />}

                            {/* {billerData.icon && (
                                <Avatar alt={name} sx={{ bgcolor: deepOrange[500] }}>
                                    {billerData.icon}
                                </Avatar>
                            )} */}
                        </Grid>
                        <Grid item xs zeroMinWidth>
                            <Typography
                                variant="h5"
                                sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}
                            >
                                {billerData.biller_name}
                            </Typography>
                            <Typography
                                variant="subtitle2"
                                sx={{ mt: 0.5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}
                            >
                                {billerData.description}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Tooltip title="Pay Now" placement="top">
                                <Button
                                    component={Link}
                                    to={'/pay-now/view/' + billerData.name}
                                    onClick={() => {
                                        dispatch({
                                            type: LOAD_BILLER,
                                            billerData: billerData
                                        });
                                    }}
                                    variant="outlined"
                                    color="secondary"
                                    fullWidth
                                    sx={btnSX}
                                >
                                    Pay Now
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    );
};

PaynowBillerCard.propTypes = {
    billerData: PropTypes.object
};

export default PaynowBillerCard;
